import React, { FC, useEffect, useState } from 'react';
import { LandscapeAboutCommittedBuyersTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import {
  deleteCompactSupporter,
  fetchCompactSupportersByLandscapeId,
} from '../../../store/tradeAPI/commodity/reducers/landscape-supporters.slice';
import { useParams } from 'react-router-dom';
import Spinner from '../../atoms/Spinner/Spinner';
import { fetchBuyerById } from '../../../store/buyerAPI/buyer/reducers/buyer.slice';
import { BuyerResponseDto } from '../../../store/buyerAPI/buyer/dto/response/buyer-response.dto';
import cn from 'classnames';
import styles from './LandscapeAboutCommittedBuyersPage.module.css';
import { LandscapeBuyerRelationType } from '../../../store/landscapeAPI/landscape/landscape-buyer-relation-type';
import { LocalesLanguagesConstants } from '../../../locales/locales';

interface LandscapeAboutCommittedBuyersPageProps {}

interface TableItem {
  id: string;
  logo: string;
  name: string;
  url: string;
  relationType: LandscapeBuyerRelationType;
}

const LandscapeAboutCommittedBuyersPage: FC<
  LandscapeAboutCommittedBuyersPageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams();

  const [organizations, setOrganizations] = useState<TableItem[]>();

  const { compactSupporters: supporters, status: supporterStatus } =
    useSelector((state: RootState) => state.landscapeSupportersSlice);

  const { status } = useSelector((state: RootState) => state.buyerSlice);

  useEffect(() => {
    if (id) {
      dispatch(fetchCompactSupportersByLandscapeId(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    (async () => {
      const temp: TableItem[] = [];
      if (supporters) {
        for (let i = 0; i < supporters.length; i++) {
          await dispatch(
            fetchBuyerById({
              id: supporters[i].organizationId,
              language: LocalesLanguagesConstants.en,
            })
          )
            .unwrap()
            .then((buyer: BuyerResponseDto) => {
              const tableItem: TableItem = {
                id: supporters[i].id,
                logo: buyer.logo ?? '',
                name: buyer.name ?? '',
                url: buyer.url ?? '',
                relationType: supporters[i].relationType,
              };
              temp.push(tableItem);
            });
        }
        setOrganizations(temp);
      }
    })();
  }, [supporters, dispatch]);

  const handleDelete = async (supporterId: string) => {
    await dispatch(deleteCompactSupporter(supporterId)).unwrap();
    dispatch(fetchCompactSupportersByLandscapeId(id!));
  };

  if (supporterStatus === 'loading' || status === 'loading') {
    return <Spinner />;
  }

  return (
    <>
      {organizations && (
        <div className={cn(styles.wrapper)}>
          <LandscapeAboutCommittedBuyersTemplate
            organizations={organizations}
            handleDelete={handleDelete}
          />
        </div>
      )}
    </>
  );
};

export default LandscapeAboutCommittedBuyersPage;
